var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import axios from "axios";
import LocationItem from "./location-item";
import FeaturedItem from "./featured-item";
import CONSTS from "../../consts";
const SwiperJS = require("react-id-swiper");
const Swiper = SwiperJS.default;
export default class BrowseLocation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collectionFive: {},
            collectionFiveProduct: {},
            collectionSix: {},
            collectionSixProduct: {},
            collectionSeven: {},
            collectionSevenProduct: {},
        };
    }
    componentDidMount() {
        this.getCollectionFive();
        this.getCollectionSix();
        this.getCollectionSeven();
    }
    getCollectionFive() {
        return __awaiter(this, void 0, void 0, function* () {
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Collections(5)?$expand=FeaturedProduct`;
            const response = yield axios.get(query);
            this.setState({
                collectionFive: response.data,
                collectionFiveProduct: response.data.FeaturedProduct
            });
        });
    }
    getCollectionSix() {
        return __awaiter(this, void 0, void 0, function* () {
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Collections(6)?$expand=FeaturedProduct`;
            const response = yield axios.get(query);
            this.setState({
                collectionSix: response.data,
                collectionSixProduct: response.data.FeaturedProduct,
            });
        });
    }
    getCollectionSeven() {
        return __awaiter(this, void 0, void 0, function* () {
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Collections(7)?$expand=FeaturedProduct`;
            const response = yield axios.get(query);
            this.setState({
                collectionSeven: response.data,
                collectionSevenProduct: response.data.FeaturedProduct,
            });
        });
    }
    render() {
        let collectionFive = this.state.collectionFive;
        let collectionFiveProduct = this.state.collectionFiveProduct;
        let collectionSix = this.state.collectionSix;
        let collectionSixProduct = this.state.collectionSixProduct;
        let collectionSeven = this.state.collectionSeven;
        let collectionSevenProduct = this.state.collectionSevenProduct;
        return (React.createElement("div", { className: "browse-location" },
            React.createElement("div", { className: "main-location" },
                React.createElement(LocationItem, { header: collectionFive.Name, title: collectionFive.Title, titleColor: "#df6126", desc: collectionFive.Description, location: collectionFiveProduct == null ? "" : collectionFiveProduct.AgentName, buttonText: collectionFive.ButtonText, imgPath: `${CONSTS.STORAGEURL}/${CONSTS.COLLECTIONCONTAINER}/5.jpg`, color: "#68235b", drink: collectionFiveProduct == null ? "" : collectionFiveProduct.Name, buttonLink: "Products/Collections/5", active: collectionFive.Active, paidAdvertisement: collectionFive.PaidAdvertisement }),
                React.createElement(LocationItem, { header: collectionSix.Name, title: collectionSix.Title, titleColor: "#9cd9e3", desc: collectionSix.Description, location: collectionSixProduct == null ? '' : collectionSixProduct.AgentName, buttonText: collectionSix.ButtonText, imgPath: `${CONSTS.STORAGEURL}/${CONSTS.COLLECTIONCONTAINER}/6.jpg`, color: "#067674", drink: collectionSixProduct == null ? '' : collectionSixProduct.Name, buttonLink: "Products/Collections/6", active: collectionSix.Active, paidAdvertisement: collectionSix.PaidAdvertisement })),
            React.createElement("div", { className: "featured-location" },
                React.createElement(FeaturedItem, { header: collectionSeven.Name, title: collectionSeven.Title, desc: collectionSeven.Description, location: collectionSevenProduct == null ? '' : collectionSevenProduct.AgentName, buttonText: collectionSeven.ButtonText, imgPath: collectionSevenProduct == null ? '' : `${CONSTS.STORAGEURL}/${CONSTS.PRODUCTCONTAINER}/${collectionSevenProduct.SKU}.jpg`, bgPath: `${CONSTS.STORAGEURL}/${CONSTS.COLLECTIONCONTAINER}/7.jpg`, drink: collectionSevenProduct == null ? '' : collectionSevenProduct.Name, buttonLink: "Products/Collections/7", active: collectionSeven.Active, paidAdvertisement: collectionSeven.PaidAdvertisement }))));
    }
}
//# sourceMappingURL=browse-location.js.map